angular
    .module("thor.shared.filter.query.component", [])
    .component("thorFilterQuery", {
        bindings: {
            query: "=",
            queryOptions: "="
        },
        template: require("../../shared/filter/query.html")
    });
